import React, { useState, useEffect, useContext } from "react"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import styled from "styled-components"
import RightSideBar from '../sections/section-right-side-bar'

import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import {
  findCurrentJourneyCode,
} from "../services/helperFunctions"
import {
  fetchApplicationDetails,
  saveApplication,
  generateBI
} from "../../services/apiservice"
const RadioContainer = styled.div`
  width: 100%;
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: #fff;
    padding: 2px 5px;
    z-index: 999;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    & > .radio-label {
      text-align: center;
    }
  }
  .card {
    border-radius: 1rem;
    padding: 2rem 0;
    border-radius: 15px;
    background-color: #fff;
    position: relative;
    margin: 0px;
    margin-bottom: 0px;
    cursor: pointer;
    height: 13rem;
    margin-top: 0px;
    box-shadow: 0px 0px 20px #ccc;
    transition: all 200ms;
    .amount {
      font-size:1.2rem;
      color: black;
      margin-bottom: 1.5rem;
      margin-top:-12px;
      margin-left: 4.5rem;
      border-left: 1px solid #ccc;
      padding-left: 1.5rem;
      // padding-top: .5rem;
      height: 3rem;
    }
    .desc {
      padding: 0.8rem;
      background: #ededed;
      color: black;
      text-align: center;
    }
  }
  /*Check tick start  */
  .checked {
    background: #ededed;
    color: #ededed;
    position: absolute;
    left: 1rem;
    top: 1rem;
    height: 2rem;
    width: 2rem;
    border-radius: 50%;
    padding: 6px;
    & > * {
      font-size: 1.2rem;
    }
  }
  input:checked ~ .card .checked {
    background: #fff;
   
    color: var(--lumiq-card-bg);
  }
  /*Check tick end */
  .icon-container {
    font-size: 3rem;
    padding: 1rem;
    span {
      border-radius: 50%;
      padding: 1rem;
      background: #3e505d;
      .hero-icon {
        padding-top: 8px;
        color: #fff;
      }
    }
  }
  input:checked ~ .card {
    background-color: var(--lumiq-card-bg);
    color: #fff;
    .icon-container-1 {
      span {
        background: #fff;
        .hero-icon {
          color: #3e505d;
        }
      }
    }
    .amount {
      color: white;
      margin-bottom: 1.5rem ;
      margin-top:-12px;
      margin-left: 4.5rem;
      border-left: 1px solid #ccc;
      padding-left: 1.5rem !important ;
      // padding-top: .5rem;
      height: 3rem;
      
    }
    .desc {
      padding: 0.8rem;
      background: #fff;
      color: black;
      text-align: center;
    }
  }
  input:not(:checked) ~ .card {
    /* opacity: 0.5; */
    .amount{
      color:#818181;
    }
    .desc{
      color:#3e505d;
    }
  }
`

const RadioContainer1 = styled.div`
  width: 100%;
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: #fff;
    padding: 2px 5px;
    z-index: 999;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    & > .radio-label {
      text-align: center;
    }
  }
  .card {
    border-radius: 1rem;
    padding: 2rem 0;
    border-radius: 15px;
    background-color: #fff;
    position: relative;
    margin: 0px;
    margin-bottom: 0px;
    cursor: pointer;
    height: 13rem;
    margin-top: 0px;
    box-shadow: 0px 0px 20px #ccc;
    transition: all 200ms;
    .amount {
      font-size:1.2rem;
      color: black;
      margin-bottom: 1.5rem;
      margin-top:-12px;
      margin-left: 4.5rem;
      border-left: 1px solid #ccc;
      padding-left: 1.5rem;
      // padding-top: .5rem;
      height: 3rem;
    }
    .desc {
      padding: 0.8rem;
      background: #ededed;
      color: black;
      text-align: center;
    }
  }
  /*Check tick start  */
  .checked {
    background: #ededed;
    color: #ededed;
    position: absolute;
    left: 1rem;
    top: 1rem;
    height: 2rem;
    width: 2rem;
    border-radius: 50%;
    padding: 6px;
    & > * {
      font-size: 1.2rem;
    }
  }
  input:checked ~ .card .checked {
    background: #fff;
   
    color: var(--lumiq-card-bg);
  }
  /*Check tick end */
  .icon-container {
    font-size: 3rem;
    padding: 1rem;
    span {
      border-radius: 50%;
      padding: 1rem;
      background: #3e505d;
      .hero-icon {
        padding-top: 8px;
        color: #fff;
      }
    }
  }
  input:checked ~ .card {
    background-color: var(--lumiq-card-bg);
    color: #fff;
    .icon-container-1 {
      span {
        background: #fff;
        .hero-icon {
          color: #3e505d;
        }
      }
    }
    .amount {
      color: white;
      margin-bottom: 1.5rem ;
      margin-top:-12px;
      margin-left: 4.5rem;
      border-left: 1px solid #ccc;
      padding-left: 1.5rem !important ;
      // padding-top: .5rem;
      height: 3rem;
      
    }
    .desc {
      padding: 0.8rem;
      background: #fff;
      color: black;
      text-align: center;
    }
  }
  input:not(:checked) ~ .card {
    /* opacity: 0.5; */
    .amount{
      color:#818181;
    }
    .desc{
      color:#3e505d;
    }
  }
`

export default function TeleMer(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [laTelemer, setLaTelemer] = useState(false)
  const [spTelemer, setSpTelemer] = useState(false)
  const [message, setMessage] = useState();
  const [apiResult, setApiResult] = useState();
  const [selectedOption, setSelectedOption] = useState()
  const [optionData,setOptionData] = useState()

  const asyncGenerateBi = async () => {
    if(journeyState.journeyId){
      let payloadForApplicationDetails = {
        _id : journeyState.journeyId,
      }
      fetchApplicationDetails(payloadForApplicationDetails).then( async res => {
        console.log(res, "fhggkgjd")
        let payload = {
          journeyId: journeyState.journeyId,
          planOption: journeyState.planOption,
          teleMerInd: true
        }
        let data
        console.log(journeyState);
        try {
          data = await generateBI(payload);
        }catch(err){
          console.log("error while generating bi choose your plan section", err)
        }
        
        console.log(data?.data, "data from generate bi")
        // props.setCallBi(false)
        if (data?.data?.BIJson) {
          console.log("inside if");
          let temp = {
            premium: (data.data?.finalKeys?.INSTALLMENT_PREM_LA_RIDER) || 0,
            totalPremium: (data.data?.finalKeys.PREMIUM)|| 0,
            lumpsumAmount: data.data.sumAssured,
            POLICYTERM: data.data.finalKeys?.POLICYTERM,
            BIJson: data.data.BIJson,
            TransactionId: data.data.TransactionId
          }
          // if(!journeyState.premium){
          //   downloadPdf(data.data.TransactionId)
          // }
          // journeyState["premium"] = temp.totalPremium
          setApiResult(temp)
          setSelectedOption(temp)
          setJourneyState(prev => {
            return {
              ...prev,
              premium: temp.totalPremium,
            }
          })
        }else{
          if(data?.data?.InputValidationStatus && data?.data?.InputValidationStatus[0]?.ErrorMessage){
            const str = data?.data?.InputValidationStatus[0]?.ErrorMessage.map(el => el.value).join(',')
            setMessage(str);
            return;
          }
          else{
            setMessage(data?.data?.Message);
            return;
          }
        }
        if(data.optionData){
          let temp = {}
          console.log(data.optionData.option3);
          if(data.optionData.teleLa ||data.optionData.teleSpouse ){
            let optionData = {
              // premium: (data.optionData.option3.finalKeys.TOTAL_INSTALLMENT) || 0,
              // totalPremium: (data.optionData.option3.finalKeys.PREMIUM) || 0,
              teleLaPremium : data?.optionData?.teleLa?.finalKeys?.PREMIUM || 0,
              teleSpousePremium : data?.optionData?.teleSpouse?.finalKeys?.PREMIUM || 0,
            }
            temp["optionData"] = optionData
            console.log(temp);
            setOptionData(temp)
            console.log(optionData);
          }
        }
      })
      
    }
  }

  //code to call generate bi
  useEffect(async() => {
    await asyncGenerateBi()
  },[])
  
  //code to check default options
  useEffect(async () =>{
    if(journeyState.showLaTeleMer){
      setLaTelemer(true)
      console.log(laTelemer);
    }
    if(journeyState.showSpTeleMer){
      setSpTelemer(true)
      console.log(spTelemer);
    }
  },[journeyState.showLaTeleMer,journeyState.showSpTeleMer])

  const handleProceed = async ev => {
    let temp, tempSectionIndexToChange, tempSectionToShow
 
      temp = journeyState.journeySteps
      tempSectionIndexToChange = temp.pages.findIndex(element => element.pageId === "viewBenefitIllustrationPage")
      console.log(temp.pages[tempSectionIndexToChange].sections);
    if(!laTelemer && !spTelemer){
      tempSectionToShow = temp.pages[tempSectionIndexToChange].sections.filter(element => {return(element.sectionId !== "iselectTeleMedicalQuestionaire" && element.sectionId !== "iselectTeleMedicalSpouseQuestionaire")})
    }else if(laTelemer && spTelemer){
      tempSectionToShow = temp.pages[tempSectionIndexToChange].sections
    }else if(!laTelemer && spTelemer){
      tempSectionToShow = temp.pages[tempSectionIndexToChange].sections.filter(element => {return(element.sectionId !== "iselectTeleMedicalQuestionaire")})
    }else if(laTelemer && !spTelemer){
      tempSectionToShow = temp.pages[tempSectionIndexToChange].sections.filter(element => {return(element.sectionId !== "iselectTeleMedicalSpouseQuestionaire")})
    }else if(!laTelemer){
      tempSectionToShow = temp.pages[tempSectionIndexToChange].sections.filter(element => {return(element.sectionId !== "iselectTeleMedicalQuestionaire" && element.sectionId !== "iselectTeleMedicalSpouseQuestionaire")})
    }else if(laTelemer){
      tempSectionToShow = temp.pages[tempSectionIndexToChange].sections.filter(element => {return(element.sectionId !== "iselectTeleMedicalSpouseQuestionaire")})
    }
    console.log(tempSectionIndexToChange, "adadadada")
    console.log(tempSectionToShow,"section to show");
    temp.pages[tempSectionIndexToChange].sections = tempSectionToShow

     setJourneyState(prev => {
       return ({
         ...prev,
         journeySteps: temp,
       })
     })
    //  props.setCurrentSectionIndex(prev => prev + 1)


    let applicationData = JSON.parse(JSON.stringify(journeyState.journeyData))
    let currentPageIndexToFind = journeyState.journeyData.findIndex(element => element.pageId === props.pageId)
    console.log(currentPageIndexToFind);
    
    if(currentPageIndexToFind === -1){
        let payloadToAdd = {
            pageId: props.pageId,
            pageData: [{
                sectionId: props.sections[props.currentSectionIndex]?.sectionId,
                sectionData: {
                    "teleMerInd": laTelemer?"Y":"N",
                    "formUwSpouseInd":spTelemer?"telemer":"medical",
                }
            }]
        }
        console.log(payloadToAdd);
        applicationData.push(payloadToAdd)
        console.log(applicationData);
    }else{
        let pageToAddData = journeyState.journeyData[currentPageIndexToFind]
        let sectionToAdd =  {
            sectionId: props.sections[props.currentSectionIndex]?.sectionId,
            sectionData: {
                "teleMerInd": laTelemer?"Y":"N",
                "formUwSpouseInd":spTelemer?"telemer":"medical",
            }
        }
        let filteredPageData = pageToAddData.pageData?.filter(element => element.sectionId !== props.sections[props.currentSectionIndex]?.sectionId)
        filteredPageData.push(sectionToAdd)
        pageToAddData.pageData = filteredPageData

        let filteredSendPaylod = applicationData.filter(element => element.pageId !== props.pageId)
        filteredSendPaylod.push(pageToAddData)
        applicationData = filteredSendPaylod
    }
    


    let sendPayload = {
      applicationData:  applicationData, 
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex + 1,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        premium: journeyState.premium,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
      },
    }
    saveApplication(sendPayload).then(async res => { 
      let payload = {
        journeyId: journeyState.journeyId,
        planOption: journeyState.planOption,
      }
      let data
      console.log(journeyState);
      try {
        data = await generateBI(payload);
      }catch(err){
        console.log("error while generating bi choose your plan section", err)
      }
      setJourneyState((prev) => {
        return ({
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex + 1,
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex + 1].sectionId,
          journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex + 1].sectionId)
        })
      })
        props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
    }).catch(err => {
      console.log(err, "err in saveApplication")
    })
  }

  const handlePrevious = () => {
    props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
      // setJourneyState(prev => {
      //   return {
      //     ...prev,
      //     lastPage: props.currentPageIndex,
      //     lastSection: props.currentSectionIndex,
      //     lastPageCode: props.pageId,
      //     lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      //     journeyCode: findCurrentJourneyCode(
      //       props.pageId,
      //       props.sections[props.currentSectionIndex].sectionId
      //     ),
      //   }
      // })
  }

  // code of tab enter
  const handleEnterPrevious = (event) => {
    if (event?.key == 'Enter') {
      handlePrevious();
    }
  }

  const handleLaMedicalChange = ({ target }) => {
    console.log(target.value);
    if (target.value === "laPhysical") {
      setLaTelemer(false)
    } else if (target.value === "laTelemer") {
      setLaTelemer(true)
    }
  }

  const handleSpMedicalChange = ({ target }) => {
    console.log(target.value);
    if (target.value === "spPhysical") {
      setSpTelemer(false)
    } else if (target.value === "spTelemer") {
      setSpTelemer(true)
    }
  }

 
  return (
    <>
      <style>{
        ` 
          .card{
            width:100%;
            height:8rem !important;
          }
          .text-tool-tip-design {
            position: relative;
            right: 0px;
            top: -2px;
            width: 15px;
            height: 15px;
            font-size: 10px;
            padding: 1px;
            line-height: 13px;
          }
          .tele-mer-tooltips {
            top: -10px !important;
          }
          .tooltip-col {
            width: 20px;
            height: 20px;
            border-radius: 50px;
            color: #fff;
            background-color: #a6a6a6;
            position: absolute;
            right: -4px;
            top: 5px;
            font-size: 10px;
            line-height: 20px;
            font-family: Helvetica Neue LT Com;
            text-transform: lowercase;
          }
    
          .tooltip-col {
              position: relative;
              display: inline-block;
              cursor: pointer;
              text-align: center;
          }
          .tele-mer-tooltips .tooltiptext4 {
            width: 241px !important;
            height: 112px !important;
            top: -124px !important;
            font-weight: normal !important;
            right: -108px !important;
          }
          .tooltiptext4:active {
            opacity: 0 !important;
            width: 249px  !important;
            height: 53px  !important;
            background-color: #767676  !important;
            color: #fff  !important;
            text-align: center  !important;
            border-radius: 0px  !important;
            padding: 15px 10px  !important;
            box-sizing: border-box  !important;
            position: absolute  !important;
            z-index: 1  !important;
            top: -63px  !important;
            right: -8px  !important;
            font-size: 13px  !important;
            line-height: 17px !important;
            transition: all 200ms !important;
          }
          .text-tool-tip-design .tooltiptext4::after {
              left: auto;
          }
        .tele-mer-tooltips .tooltiptext4::after {
            right: 106px !important;
        }
        .tooltiptext4::after {
            content: "";
            position: absolute;
            bottom: -20px;
            right: 6px;
            border-width: 10px;
            border-style: solid;
            border-color: #767676 transparent transparent transparent;
        }
        .desc{
          padding:0.3rem !important;
          // border-radius:14px;
        }
        .amount{
          margin-bottom:1.5rem;
        }
            .Bi-page-pay-structure-tele .option-buit-design-new-new-design h2 {padding: 2px 0px;}
            .Bi-page-pay-structure-tele .option-buit-design-new-structure-sec1, .Bi-page-pay-structure-tele .option-buit-design-new-structure-sec2,.Bi-page-pay-structure-tele .option-buit-design-new-structure-sec3, .Bi-page-pay-structure-tele .option-buit-design-new-structure-sec4 {
            height: 116px;
      }
        .heading-design-tel-met{ font-size:17px; font-weight:bold;}
        @media (max-width: 767px) {
          .heading-design-tel-met{ font-size:14px; font-weight:bold;}
            .Bi-page-pay-structure-tele .option-buit-design-new-structure-sec1, .Bi-page-pay-structure-tele .option-buit-design-new-structure-sec2,.Bi-page-pay-structure-tele .option-buit-design-new-structure-sec3, .Bi-page-pay-structure-tele .option-buit-design-new-structure-sec4 {
              height: 100px;
          }
          .option-buit-design-new-structure-sec1 .checkmark, .option-buit-design-new-structure-sec2 .checkmark, .option-buit-design-new-structure-sec3 .checkmark, .option-buit-design-new-structure-sec4 .checkmark {
          left: 0px;
              top: 15px;
       }
      }
        
        `

      }
      </style>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            {journeyState.showLaTeleMer &&
            <div class="iselect-box-design">
              <div class="heading-design">
                <div class="iselect-padding left-side-head">
                  <h1 class="iselect-heading">Medical Check-up</h1>
                </div>
                <div class="app-quatation q3-mt1 hidden-desktop-screen">
                  <div class="application-design-number">
                    Application Number: {journeyState.applicationNo}
                  </div>
                </div>
              </div>
              <div class="iselect-padding details-esign">
                <div class="clearfix">
                </div>
                <h2 class="heading-design-tel-met">
                  Select preferred option for your medical check-up
                </h2>
                <div className="d-flex row">
                  <div className="col-lg-6 col-md-12 col-12">
                    <RadioContainer>
                      <div style={{ borderRadius: '15px' }} className="provider" tabIndex="0">
                        <label className="width">
                          <input
                            onChange={handleLaMedicalChange}
                            type="radio"
                            name="laPhysical"
                            value="laPhysical"
                            hidden
                            checked={!laTelemer}
                          />
                          <div className="card">
                            <div className="checked">
                              <FaCheck />
                            </div>
                            <div className="amount">
                              <span>
                                Physical medical
                                <span
                                  class="tooltip-col text-tool-tip-design existing-tool-tip tele-mer-tooltips"
                                >
                                  <div class="tool">i</div>
                                  <span
                                    class="tooltiptext4"
                                    style={{ "textTransform": "initial !important" }}
                                  >For physical medical, you will be required to visit the health centre for assessment of your health conditions and fitness.</span
                                  >
                                </span>
                              </span>
                            </div>

                            <div className="desc">
                              <span>
                                Premium Amount {journeyState.premium}
                              </span>
                            </div>
                          </div>
                        </label>
                      </div>
                    </RadioContainer>
                  </div>
                  <div className="col-lg-6 col-md-12 col-xs-12 ">
                    <RadioContainer>
                      <div style={{ borderRadius: '15px' }} className="provider" tabIndex="0" >
                        <label className="width">
                          <input
                            onChange={handleLaMedicalChange}
                            type="radio"
                            name="laTelemer"
                            value="laTelemer"
                            hidden
                            checked={laTelemer}
                          />
                          <div className="card">
                            <div className="checked">
                              <FaCheck />
                            </div>
                            <div className="amount">
                              <span>
                                Tele-medical
                                <span
                                  class="tooltip-col text-tool-tip-design existing-tool-tip tele-mer-tooltips"
                                >
                                  <div class="tool">i</div>
                                  <span
                                    class="tooltiptext4"
                                    style={{ "textTransform": "initial !important" }}
                                  >A tele-medical check-up is done through a phone call with the doctor to gather risk related personal information &amp; medical history of the proposer.</span
                                  >
                                </span>
                              </span>
                            </div>

                            <div className="desc">
                              <span>
                                Premium Amount {optionData?.optionData?.teleLaPremium}
                              </span>
                            </div>
                          </div>
                        </label>
                      </div>
                    </RadioContainer>
                  </div>
                </div>
              </div>
            </div>
            }
            
               {journeyState.showSpTeleMer && 
            
               <div class="iselect-padding details-esign">
               <div class="clearfix"></div>
               <h2 class="heading-design-tel-met">
               Select preferred option for your spouse medical check-up
               </h2>
               <div className="d-flex row">
                 <div className="col-lg-6 col-md-12 col-12 ">
                   <RadioContainer1>
                     <div style={{ borderRadius: '15px' }} className="provider" tabIndex="0">
                       <label className="width">
                         <input
                          onChange={handleSpMedicalChange}
                           type="radio"
                           name="spPhysical"
                           value="spPhysical"
                           hidden
                           checked={!spTelemer}
                         />
                         <div className="card">
                           <div className="checked">
                             <FaCheck />
                           </div>
                           <div className="amount">
                             <span>
                               Physical medical
                               <span
                                 class="tooltip-col text-tool-tip-design existing-tool-tip tele-mer-tooltips"
                               >
                                 <div class="tool">i</div>
                                 <span
                                   class="tooltiptext4"
                                   style={{ "textTransform": "initial !important" }}
                                 >For physical medical, you will be required to visit the health centre for assessment of your health conditions and fitness.</span
                                 >
                               </span>
                             </span>
                           </div>
 
                           <div className="desc">
                             <span>
                             Premium Amount {journeyState.premium}
                             </span>
                           </div>
                         </div>
                       </label>
                     </div>
                   </RadioContainer1>
                 </div>
                 <div className="col-lg-6 col-md-12 col-xs-12">
                   <RadioContainer1>
                     <div style={{ borderRadius: '15px' }} className="provider" tabIndex="0" >
                       <label className="width">
                         <input
                          onChange={handleSpMedicalChange}
                           type="radio"
                           name="spTelemer"
                           value="spTelemer"
                           hidden
                           checked={spTelemer}
 
                         />
                         <div className="card">
                           <div className="checked">
                             <FaCheck />
                           </div>
                           <div className="amount">
                             <span>
                               Tele-medical
                               <span
                                 class="tooltip-col text-tool-tip-design existing-tool-tip tele-mer-tooltips"
                               >
                                 <div class="tool">i</div>
                                 <span
                                   class="tooltiptext4"
                                   style={{ "textTransform": "initial !important" }}
                                 >A tele-medical check-up is done through a phone call with the doctor to gather risk related personal information &amp; medical history of the proposer.</span
                                 >
                               </span>
                             </span>
                           </div>
 
                           <div className="desc">
                             <span>
                             Premium Amount {optionData?.optionData?.teleSpousePremium}
                             </span>
                           </div>
                         </div>
                       </label>
                     </div>
                   </RadioContainer1>
                 </div>
               </div>
             </div>
             }
            <div className="container hidden-desktop-screen">
            <div className="">
              <div className="but-center text-center align-center-choose-plan "  style={{"width":"100%"}}>
                <div className="provider submit-btn cen" style={{marginRight:"5px"}} tabIndex="0"
                onKeyPress={(e)=>handleEnterPrevious(e)}>
                  <a aria-hidden="true" onClick={handlePrevious}>Previous</a>
                </div>
                <input
                  type="submit"
                  className="provider previous-btn cen"
                  tabIndex="0"
                  style={{
                    color: "white",
                    padding: "14px 40px",
                    border: "none",
                    marginLeft: "8px",
                  }}
                  value="Proceed"
                  onClick={handleProceed}
                />
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      {/* <!--mobile view button--> */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
      <div className="iselect-mg-bottom">
        <div className="col-md-12">
          <div className="but-center text-center">
            <div className="submit-btn cen">
              <a aria-hidden="true" onClick={handlePrevious}>Previous</a>
            </div>
            <input
              type="submit"
              className="previous-btn cen"
              style={{
                color: "white",
                padding: "14px 40px",
                border: "none",
                marginLeft: "8px",
              }}
              onClick={handleProceed}
              value="Proceed"
            />
          </div>
        </div>
      </div>
    </div>
    {/* <!--mobile view button-->   */}
    </>
  )
}